import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterType"];
import { Fragment } from 'react';
import styled from 'styled-components';
import { Set as ImmutableSet } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UITag from 'UIComponents/tag/UITag';
import { useSearchParam, useSearchParamInput, useLocationWithoutParams
// @ts-expect-error Could not find a declaration file for module
} from '../../hooks/searchParamHooks';
import { device } from '../../constants/StyledComponentConstants';
import UsageTracker from '../../utils/UsageTracker';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useFilterOptions } from '../../features/filters/';
import { FilterItems } from './FilterItems';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClearFiltersRouterLink = styled(UIRouterLink).withConfig({
  displayName: "RouterDropdownFilter__ClearFiltersRouterLink",
  componentId: "sc-1v0r3ja-0"
})(["white-space:nowrap;padding-left:10px;top:3px;position:relative;"]);
export const StyledTagsContainer = styled.div.withConfig({
  displayName: "RouterDropdownFilter__StyledTagsContainer",
  componentId: "sc-1v0r3ja-1"
})(["line-height:2.4;margin:-10px 0 0 -4px;padding-bottom:16px;display:flex;flex-wrap:wrap;@media screen and ", "{flex-wrap:nowrap;overflow-x:scroll;margin:0;padding-left:8px;padding-top:5px;padding-bottom:6px;&:empty{padding:0;}a:last-child{padding-right:12px;}&::-webkit-scrollbar{width:0;background:transparent;height:0;}}"], device.mobile);
const onClearFiltersClick = () => {
  UsageTracker.track('interaction', {
    action: 'clear-filters-click'
  });
};
export const ClearFiltersLink = ({
  filtersToClear
}) => {
  const [isClearable, destination] = useLocationWithoutParams(filtersToClear);
  return isClearable ? /*#__PURE__*/_jsx(ClearFiltersRouterLink, {
    "data-test-id": "clear-top-filters",
    onClick: onClearFiltersClick,
    to: destination,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.filters.clearFilters"
    })
  }) : null;
};
export const RouterChecklistFilter = ({
  defaultItem,
  filterType,
  replace,
  hideReset
}) => {
  const options = useFilterOptions(filterType);
  const [paramValue, changeHandler] = useSearchParamInput(filterType, replace);
  const [__, changeHandlerReplace] = useSearchParamInput(filterType, true);
  let valuesSet = ImmutableSet(paramValue);
  if (!valuesSet.size && defaultItem) {
    valuesSet = valuesSet.add(defaultItem);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!hideReset && /*#__PURE__*/_jsx(UICheckbox, {
      checked: valuesSet.isEmpty(),
      "data-test-id": `${filterType}-filterReset`,
      onChange: changeHandlerReplace,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.filterReset`
      })
    }, "filterReset"), options.map(item => /*#__PURE__*/_jsx(UICheckbox, {
      alignment: "end",
      checked: valuesSet.contains(item),
      "data-test-id": `${filterType}-${item}`,
      onChange: changeHandler,
      value: item,
      children: filterType === 'language' ? LanguageNames[item.toLowerCase()] : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.${item}`
      })
    }, item))]
  });
};
const DropdownButtonText = styled(FormattedMessage).withConfig({
  displayName: "RouterDropdownFilter__DropdownButtonText",
  componentId: "sc-1v0r3ja-2"
})(["font-weight:500;"]);
const RouterDropdownFilter = _ref => {
  let {
      filterType
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIDropdown, {
    buttonText: /*#__PURE__*/_jsx(DropdownButtonText, {
      message: `learningCenter.topFilters.${filterType}.filterTitle`
    }),
    buttonUse: "transparent",
    "data-test-id": `filter-type-${filterType}`,
    children: /*#__PURE__*/_jsx(RouterChecklistFilter, Object.assign({
      filterType: filterType
    }, props))
  });
};
export const RouterFilterTags = ({
  filterType
}) => {
  const [paramValue, setParam] = useSearchParam(filterType);
  const valueSet = ImmutableSet(paramValue);
  const options = FilterItems[filterType] || [];
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Fragment, {
    children: options.map(item => valueSet.has(item) && /*#__PURE__*/_jsx("div", {
      onClick: () => {
        setParam(valueSet.delete(item).toArray());
        UsageTracker.track('filterInteraction', {
          action: 'filter-deselected',
          value: item,
          key: filterType,
          isTag: true
        });
      },
      children: /*#__PURE__*/_jsxs(UITag, {
        closeable: true,
        "data-test-id": `filter-tag-${filterType}-${item}`,
        inline: true,
        children: [!isMobile && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.topFilters.${filterType}.filterTitle`
          }), ":", ' ']
        }), filterType === 'language' ? LanguageNames[item.toLowerCase()] : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${filterType}.${item}`
        })]
      }, `${filterType}-${item}`)
    }, item))
  });
};
export default RouterDropdownFilter;